export const lightTheme = {
  body: "#FFF",
  text: "#363537",
  toggleBorder: "#FFF",
  background: "#F6F8FA", // Light gray for backgrounds of sections
  headerBg: "#FFFFFF",
  cardBg: "#FFFFFF",
  cardBorder: "#E1E4E8",
  primary: "#0366d6", // A nice blue
  secondary: "#586069", // Medium gray
  accent: "#28a745", // Green for accents or highlights
  link: "#0366d6",
  linkHover: "#005cc5",
  buttonText: "#FFFFFF",
  // ... add more specific colors as needed
};

export const darkTheme = {
  body: "#161B22", // Dark GitHub-like background
  text: "#C9D1D9", // Light gray text
  toggleBorder: "#6B8096",
  background: "#0D1117", // Slightly darker background for sections
  headerBg: "#161B22",
  cardBg: "#21262D", // Darker card background
  cardBorder: "#30363D",
  primary: "#58A6FF", // Lighter blue for dark mode
  secondary: "#8B949E", // Lighter gray
  accent: "#3FB950", // Lighter green
  link: "#58A6FF",
  linkHover: "#79C0FF",
  buttonText: "#FFFFFF",
  // ... add more specific colors as needed
};
